import { FormTemplate } from "components/modal/templates";
import React from "react";
import { apply } from "sources/books/customPointTypes";
import { config, initialState } from "../formConfig";
import Markup from "./markup";

class CreatePointModal extends FormTemplate {
    sendRequest = (stateData) => {
        return apply(stateData);
    };

    renderBodyInner = () => {
        const { config } = this.props;
        return <Markup {...config} renderField={this.renderField} renderCheckbox={this.renderCheckbox} />;
    };
}

const ConfiguredModal = (props) => <CreatePointModal {...props} config={config} initialState={initialState} />;

export default ConfiguredModal;
